import { useState, useEffect } from 'react';

export function useBrowserInfo() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    const updateTime = () => {
      setCurrentTime(new Date());
    };

    // Set up event listeners
    window.addEventListener('resize', handleResize);

    // Update time every second
    const timeInterval = setInterval(updateTime, 1000);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(timeInterval);
    };
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short'
    });
  };

  return {
    windowSize,
    currentTime: formatTime(currentTime),
    devicePixelRatio: window.devicePixelRatio || 1
  };
}
